import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Header, Footer } from "@/components/fc/parts";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dossier = params.get("dossier");
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-lg rounded-2xl border border-border bg-card p-8 text-center" data-testid="payment-cancel">
          <XCircle size={40} className="mx-auto mb-4" style={{ color: "var(--fc-secondary-text)" }} />
          <h1 className="font-serif text-2xl font-semibold text-foreground">Paiement non finalisé</h1>
          <p className="mt-3 text-sm" style={{ color: "var(--fc-secondary-text)" }}>
            Votre paiement n'a pas été effectué et aucun montant n'a été débité. Votre dossier reste
            enregistré : vous pouvez reprendre le paiement à tout moment.
          </p>
          {dossier && (
            <button
              type="button"
              onClick={() => navigate(-1)}
              data-testid="retry-payment-button"
              className="fc-navy-btn mt-6 w-full rounded-xl px-6 py-3 text-sm font-semibold"
            >
              Revenir en arrière
            </button>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
